var media_x801 = {
    name: "media_x801",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [71,0,6,173,2,167,1,172,2,41,6,179,35,23,17,162,2,59,154,177,35,106,8,176,2,0,0,63,213,85,111,110,173,162,16,64],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [71,0,6,169,2,167,1,169,2,43,6,149,35,29,17,161,2,86,154,141,35,122,8,162,2,0,0,63,213,85,109,119,117,162,16,64],
        },
        {
            function: "KEY_MOVIE",
            name: "KEY_MOVIE",
            icon: "KEY_MOVIE",
            command: [71,0,6,169,2,173,1,162,2,43,6,153,35,29,17,161,2,60,154,178,35,106,8,174,2,0,0,63,213,85,110,253,106,162,16,64],
        },
        {
            function: "KEY_TF/SD",
            name: "KEY_TF/SD",
            icon: "KEY_TF/SD",
            command: [71,0,6,166,2,178,1,161,2,44,6,184,35,30,17,158,2,88,154,147,35,113,8,170,2,0,0,63,213,85,111,125,90,162,16,64],
        },
        {
            // function: "KEY_BLUETOOTH",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [71,0,6,163,2,174,1,168,2,45,6,144,35,25,17,161,2,93,154,142,35,105,8,174,2,0,0,63,213,85,123,109,109,162,16,64],
        },
        {
            function: "KEY_WIFI",
            name: "KEY_WIFI",
            icon: "KEY_WIFI",
            command: [71,0,6,174,2,177,1,174,2,26,6,177,35,22,17,175,2,94,154,149,35,108,8,167,2,0,0,63,213,85,106,187,245,162,16,64],
        },
        {
            function: "KEY_RADIO",
            name: "KEY_RADIO",
            icon: "KEY_RADIO",
            command: [71,0,6,169,2,168,1,175,2,38,6,167,35,22,17,173,2,77,154,157,35,119,8,163,2,0,0,63,213,85,117,182,237,162,16,64],
        },
        {
            function: "KEY_USB",
            name: "KEY_USB",
            icon: "KEY_USB",
            command: [71,0,6,175,2,163,1,173,2,35,6,166,35,17,17,192,2,91,154,159,35,106,8,171,2,0,0,63,213,85,109,86,223,98,16,64],
        },
        {
            function: "KEY_TIMER",
            name: "KEY_TIMER",
            icon: "KEY_TIMER",
            command: [71,0,6,174,2,168,1,169,2,38,6,155,35,241,16,183,2,88,154,158,35,117,8,163,2,0,0,63,213,85,107,86,239,98,16,64],
        },
        {
            // function: "KEY_SETTING",
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [71,0,6,176,2,166,1,174,2,34,6,189,35,5,17,168,2,87,154,162,35,103,8,171,2,0,0,63,213,85,117,118,245,162,16,64],
        },
        {
            function: "KEY_HOME",
            name: "KEY_HOME",
            icon: "KEY_HOME",
            command: [71,0,6,172,2,168,1,172,2,41,6,154,35,19,17,165,2,91,154,151,35,119,8,164,2,0,0,63,213,85,107,183,173,162,16,64],
        },
        {
            // function: "KEY_RETURN",
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [71,0,6,177,2,164,1,174,2,35,6,158,35,2,17,170,2,41,154,203,35,103,8,173,2,0,0,63,213,85,107,95,186,162,16,64],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [71,0,6,175,2,167,1,167,2,40,6,161,35,24,17,163,2,85,154,169,35,105,8,171,2,0,0,63,213,85,117,221,214,162,16,64],
        },
        {
            // function: "KEY_UP",
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [71,0,6,175,2,167,1,167,2,40,6,161,35,24,17,163,2,85,154,169,35,105,8,171,2,0,0,63,213,85,117,221,214,162,16,64],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [71,0,6,171,2,166,1,177,2,36,6,160,35,17,17,169,2,82,154,162,35,109,8,167,2,0,0,63,213,85,109,222,214,162,16,64],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [71,0,6,175,2,168,1,168,2,38,6,162,35,14,17,166,2,96,154,151,35,112,8,167,2,0,0,63,213,85,125,186,182,162,16,64],
        },
        {
            // function: "KEY_DOWN",
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [71,0,6,175,2,168,1,168,2,38,6,162,35,14,17,166,2,96,154,151,35,112,8,167,2,0,0,63,213,85,125,186,182,162,16,64],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [71,0,6,174,2,170,1,167,2,38,6,153,35,20,17,167,2,75,154,163,35,111,8,168,2,0,0,63,213,85,106,239,214,162,16,64],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [71,0,6,173,2,173,1,164,2,41,6,157,35,27,17,164,2,82,154,154,35,114,8,166,2,0,0,63,213,85,109,126,234,162,16,64],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [71,0,6,172,2,169,1,175,2,35,6,167,35,11,17,169,2,78,154,158,35,108,8,169,2,0,0,63,213,85,110,238,181,162,16,64],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [71,0,6,172,2,166,1,178,2,34,6,193,35,11,17,167,2,93,154,161,35,101,8,170,2,0,0,63,213,85,119,109,173,162,16,64],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [71,0,6,177,2,167,1,166,2,40,6,162,35,24,17,165,2,79,154,158,35,114,8,163,2,0,0,63,213,85,111,94,174,162,16,64],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [71,0,6,175,2,164,1,177,2,35,6,197,35,14,17,168,2,50,154,187,35,106,8,169,2,0,0,63,213,85,119,93,174,162,16,64],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [71,0,6,177,2,169,1,170,2,35,6,169,35,238,16,169,2,79,154,164,35,109,8,167,2,0,0,63,213,85,107,175,174,162,16,64],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [71,0,6,173,2,163,1,178,2,35,6,157,35,17,17,166,2,77,154,159,35,108,8,169,2,0,0,63,213,85,123,93,110,162,16,64],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [71,0,6,174,2,168,1,176,2,34,6,178,35,3,17,171,2,73,154,172,35,101,8,172,2,0,0,63,213,85,109,175,110,162,16,64],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [71,0,6,175,2,168,1,153,2,52,6,178,35,6,17,142,2,110,154,151,35,89,8,178,2,0,0,63,213,85,117,174,238,162,16,64],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [71,0,6,176,2,167,1,167,2,39,6,158,35,13,17,166,2,87,154,146,35,115,8,167,2,0,0,63,213,85,106,215,238,162,16,64],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [71,0,6,179,2,168,1,168,2,36,6,164,35,8,17,167,2,85,154,163,35,95,8,178,2,0,0,63,213,85,125,93,94,162,16,64],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [71,0,6,178,2,164,1,176,2,34,6,173,35,3,17,170,2,57,154,187,35,101,8,172,2,0,0,63,213,85,110,175,94,162,16,64],
        },
        {
            function: "KEY_EQ",
            name: "KEY_EQ",
            icon: "KEY_EQ",
            command: [71,0,6,165,2,177,1,164,2,42,6,157,35,32,17,161,2,85,154,145,35,122,8,164,2,0,0,63,213,85,125,109,93,162,16,64],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [71,0,6,174,2,171,1,163,2,42,6,148,35,28,17,162,2,103,154,142,35,122,8,165,2,0,0,63,213,85,126,186,174,162,16,64],
        },
        {
            function: "KEY_SHUFFLE",
            name: "KEY_SHUFFLE",
            icon: "KEY_SHUFFLE",
            command: [71,0,6,175,2,166,1,164,2,43,6,175,35,2,17,149,2,106,154,164,35,84,8,179,2,0,0,63,213,85,123,218,213,162,16,64],
        },
    ]
}
export default media_x801